import { useCallback, useEffect, useRef, useState } from "react";
import { convertResponseToInlineImage } from "../TableView/Elements/ApiImage";
import warehouseImages from "../../warehouseImages";

export default (value) => {
  const [fullSrcState, setFullSrcState] = useState({
    loading: false,
    data: null,
    error: null,
  });
  const [error, setError] = useState(null);
  const abortControllerRef = useRef();

  const loadFullSizedImage = useCallback(() => {
    if (fullSrcState.loading || fullSrcState.data) {
      return;
    }

    if (value) {
      warehouseImages
        .get(value, {
          responseType: "arraybuffer",
          signal: abortControllerRef.current.signal,
        })
        .then(convertResponseToInlineImage)
        .then((src) => {
          setFullSrcState({
            loading: false,
            error: null,
            data: src,
          });
        })
        .catch((err) => {
          if (err?.message !== "canceled") {
            reportError(err);
          }

          setError("Failed to load image.");
        });
    }
  }, [fullSrcState.data, fullSrcState.loading, value]);

  useEffect(() => {
    abortControllerRef.current = new AbortController();
    loadFullSizedImage();
    return () => {
      abortControllerRef.current.abort();
    };
  }, [loadFullSizedImage]);

  return {
    image: fullSrcState,
    error: error,
  };
};
